import React, { useEffect } from "react";
import { LuPlus } from "react-icons/lu";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyGetpatientoverviewQuery } from "../../State/Api/AddpatientApiSlice";


const ClinicPatientAppointments = ({
  patientViewData,
  patientUserUniqueID,
}) => {
  const navigate = useNavigate();
  const [
    fetchpatientAppointments,
    { data: patientappointmentData = [], isFetching },
  ] = useLazyGetpatientoverviewQuery();

  const location=useLocation();
  useEffect(() => {
    if (patientUserUniqueID) {
      fetchpatientAppointments(patientUserUniqueID);
    }
  }, [patientUserUniqueID]);
  return (
    <div className="mt-2 space-y-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4">
          <div>
            <h2 className="text-xl xl:text-2xl font-semibold mb-2 tracking-tight">
              Appointment History
            </h2>
            <div className="text-sm text-gray-500">
              View all appointments and medical visits.
            </div>
          </div>
          <button
            onClick={() => {
              navigate("/AddAppointment", {
                state: {
                  showModal: true,
                  patientName: patientViewData?.basicInfo?.fullname,
                  patientUserUniqueID: patientViewData?.basicInfo?.useruniqueid,
                  fromPatientView: true,
                  from: location.pathname
                },
              });
            }}
            className="inline-flex items-center gap-2 rounded-md text-sm font-medium bg-[#171717] text-white hover:bg-[#2e2e2e] h-10 px-4 py-2 gradient-button"
          >
            <LuPlus className="h-4 w-4" /> Schedule Appointment
          </button>
        </div>

        {/* Static Table */}
        <div className="p-4">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Date & Time
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Type
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Doctor
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Notes
                  </th>
                  {/* <th scope="col" className="px-6 py-3">
                    Actions
                  </th> */}
                </tr>
              </thead>
              <tbody>
  {Array.isArray(patientappointmentData) && patientappointmentData.length > 0 ? (
    patientappointmentData.map((appointment) => (
      <tr key={appointment.appointmentID} className="odd:bg-white even:bg-gray-50 border-b">
        <td className="px-6 py-4">
          <p>
            {appointment?.appointmentDate
              ? new Date(appointment.appointmentDate)
                  .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                  .replace(/ /g, "-")
              : "N/A"}
          </p>
          <p>{appointment?.timeSlot}</p>
        </td>
        <td className="px-6 py-4">{appointment?.appointmentType}</td>
        <td className="px-6 py-4">{appointment?.doctorName}</td>
        <td className="px-6 py-4">
          <span
            className={`inline-flex items-center rounded-full text-white px-2.5 py-0.5 text-xs font-semibold
              ${
                appointment?.status === "Upcoming"
                  ? "bg-yellow-500"
                  : appointment?.status === "Today"
                  ? "bg-red-500"
                  : appointment?.status === "Completed"
                  ? "bg-green-500"
                  : "bg-gray-400"
              }
            `}
          >
            {appointment?.status}
          </span>
        </td>
        <td className="px-6 py-4 max-w-[200px] truncate">
          {appointment?.additionalInfo || "N/A"}
        </td>
      </tr>
    ))
  ) : (
    // ✅ Empty state
    <tr>
      <td colSpan="5" className="text-center py-6 text-gray-500">
        No appointments scheduled
      </td>
    </tr>
  )}
</tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClinicPatientAppointments;
